import {
	SimpleGrid, Stack, Text,
} from '@chakra-ui/react';
import { getTranslations } from 'next-intl/server';

import { AuthCard, RegisterPrompt } from '@/modules/authentication/presentation/components';
import { LoginFormContainer } from '@/modules/authentication/presentation/containers';

export const LoginScreen = async () => {
	const t = await getTranslations('authentication.login');

	return (
		<Stack gap="md">
			<Text textStyle="h1">
				{t('heading')}
			</Text>
			<AuthCard>
				<SimpleGrid alignItems="stretch" columns={2} gap="md">
					<LoginFormContainer />
					<RegisterPrompt />
				</SimpleGrid>
			</AuthCard>
		</Stack>
	);
};
